import React, { useEffect } from "react";
import { useState } from "react";
import useWindowDimensions from "../../../helpers/WindowDimensions/windowDimensions";
import TmpIconCustom from "../TmpIconCustom/TmpIconCustom";
import Chevron from "../TmpInputSelectSearchCustom/Chevron";
import { AccordionTable, AccordionTableLabel, Collapsable, ContentAccordionTable, ContentData, ContentLabel, ContentRow, LabelPagination, Table, TableBody, TableFoot, TableHead, TableRow, Wrapper } from "./Style";
import { style } from "./StyleType";
import DateToString from "../../../helpers/Strings/DateToString";
import TmpButtonIconCustom from "../TmpButtonIconCustom/TmpButtonIconCustom";
import { ReactComponent as IconEditar } from "../../../assets/icons/editar.svg";
import { ReactComponent as IconExcluir } from "../../../assets/icons/excluir.svg";
import TmpModalCustom from "../TmpModalCustom/TmpModalCustom";
import TmpButtonCustom from "../TmpButtonCustom/TmpButtonCustom";
import CheckLabel from "../TmpCheckLabelCustom/TmpCheckLabelCustom";


interface TmpTableBaseCustomProps {
    columns: ITableColumnsProps[];
    title?: string;
    rows: any[];
    rowsDeleted?: any[];
    showPagination?: boolean;
    itemsPerPage?: number;
    actionDeleteColumn: boolean;
    actionEditColumn: boolean;
    onEditClick: (e: any) => void;
    onDeleteClick: (e: any) => void;
}

export interface ITableColumnsProps {
    title: string;
    property: string;
    mobileTitle?: string;
    width?: string;
    align?: 'left' | 'center' | 'right' | 'justify';
    type: 'text' | 'date' | 'boolean';
}


export default function TmpTableBaseCustom(props: TmpTableBaseCustomProps) {


    const { width } = useWindowDimensions();
    const [_isOpened, setIsOpened] = useState(false);
    const [_isOpenedModalConfirm, setIsOpenedModalConfirm] = useState(false);
    const [deleteValue, setDeleteValue] = useState();
    const [_mobileTitle] = useState(props.columns.filter((el) => el.mobileTitle)[0] || props.columns[0])
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [currentData, setCurrentData] = useState<any[]>([]);

    useEffect(() => {

        if (props.showPagination === true) {
            const totalPages = Math.ceil(props.rows.length / (props.itemsPerPage ? props.itemsPerPage : 10));
            const startIndex = (currentPage - 1) * (props.itemsPerPage ? props.itemsPerPage : 10);
            const currentData = props.rows.slice(startIndex, startIndex + (props.itemsPerPage ? props.itemsPerPage : 10));
            setCurrentData(currentData);
            setTotalPages(totalPages);
        } else {
            setCurrentData(props.rows);
        }

    }, [currentPage, props.itemsPerPage, props.rows, props.showPagination])


    const handleOpenModalChild = (e: any) => {
        setIsOpenedModalConfirm(true);
        setDeleteValue(e);
    };

    const onConfirmClick = () => {
        setIsOpenedModalConfirm(false);
        props.onDeleteClick(deleteValue);
    }

    const _handleOpen = () => {
        setIsOpened(!_isOpened)
    }

    // Função para navegar para a próxima página
    const nextPage = () => {
        setCurrentPage((prevPage) => Math.min(prevPage + 1, totalPages));
    };

    // Função para navegar para a página anterior
    const prevPage = () => {
        setCurrentPage((prevPage) => Math.max(prevPage - 1, 1));
    };

    // Passing style props to styled component
    Table.defaultProps = style;
    TableHead.defaultProps = style;
    TableBody.defaultProps = style;
    Wrapper.defaultProps = style;

    // Passing style props to styled component
    Collapsable.defaultProps = style;
    AccordionTable.defaultProps = style;
    AccordionTableLabel.defaultProps = style;
    ContentAccordionTable.defaultProps = style;
    ContentRow.defaultProps = style;
    ContentLabel.defaultProps = style;
    ContentData.defaultProps = style;

    return (
        width !== undefined && width > 768 ?
            <>
                <Table>
                    <TableHead>
                        <tr>
                            {props.columns.map((column: ITableColumnsProps, index) => (
                                <th key={index} align={column.align} style={{ width: `${(column.width === undefined ? "auto" : column.width.toString())}` }} >
                                    {column.title}
                                </th>
                            ))}

                            {(props.actionEditColumn || props.actionDeleteColumn ? <th align="center">Ações</th> : null)}
                        </tr>
                    </TableHead>
                    <TableBody>

                        {/* Apresentação das colunas */}
                        {currentData.map((row, index) => (
                            <TableRow key={index} Deleted={(props.rowsDeleted === undefined || props.rowsDeleted.length === 0 ? false : (props.rowsDeleted.includes(row)))}>
                                {props.columns.map((header, intexH) => (

                                    (header.type === "text" ?
                                        <td key={"row_" + intexH} align={header.align} >{row[header.property]}</td>
                                        : header.type === "date" ?
                                            <td key={"row_" + intexH} align={header.align}>{DateToString(row[header.property])}</td>
                                            : header.type === "boolean" ?
                                                <td key={"row_" + intexH} align={header.align}><CheckLabel value={row[header.property]} /></td>
                                                : null
                                    )

                                ))}

                                {(props.actionEditColumn || props.actionDeleteColumn ?
                                    <td align="center">
                                        <div style={{ display: "flex", justifyContent: "center",     height: "48px" }}>
                                            {props.actionEditColumn ? <TmpButtonIconCustom size="lg" type="primary" icon={<IconEditar />} typeButton="button" handleClick={() => props.onEditClick(row)} /> : null}

                                            {
                                                props.actionDeleteColumn && (props.rowsDeleted === undefined || !props.rowsDeleted.includes(row)) ?
                                                    <TmpButtonIconCustom size="lg" type="primary" icon={<IconExcluir style={{ color: "red" }} />} typeButton="button" handleClick={() => handleOpenModalChild(row)} />
                                                    : null
                                            }
                                        </div>
                                    </td>
                                    : null
                                )}

                            </TableRow>
                        ))}
                        {/* Apresentação das colunas */}

                        {/* Colunas de ações */}
                        {currentData.length === 0 && (
                            <tr>
                                {(props.actionEditColumn || props.actionDeleteColumn ?
                                    <td align="center" style={{ fontWeight: 700 }} colSpan={props.columns.length + 2} >Não existem dados para serem apresentados.</td>
                                    :
                                    <td align="center" style={{ fontWeight: 700 }} colSpan={props.columns.length + 1} >Não existem dados para serem apresentados.</td>
                                )}
                            </tr>
                        )}
                        {/* Colunas de ações */}

                    </TableBody>
                </Table>

                {/* Adiciona controles de paginação */}
                {props.showPagination ?
                    <TableFoot>
                        <div style={{ display: "flex", alignItems: "center", height: "100%" }}>
                            <TmpButtonCustom handleClick={prevPage} disabled={currentPage === 1} type="primary" size="sm" typeButton="button" >
                                Anterior
                            </TmpButtonCustom>
                            <LabelPagination>{`Página ${currentPage} de ${totalPages}`}</LabelPagination>
                            <TmpButtonCustom handleClick={nextPage} disabled={currentPage === totalPages} type="primary" size="sm" typeButton="button">
                                Próxima
                            </TmpButtonCustom>
                        </div>

                    </TableFoot>
                    : null
                }
                {/* Adiciona controles de paginação */}

                {/* Modal de confirmação de exclusão */}
                <TmpModalCustom isDoubleAction={true} isOpened={_isOpenedModalConfirm} size="sm" handleConfirm={onConfirmClick} handleCancel={() => setIsOpenedModalConfirm(false)} labelPrimary="Confirmar" labelSecondary="Cancelar"  >
                    <h3>Confirmar a exclusão</h3>
                    <h4>Você confirma a exclusão do item selecionado ?</h4>
                </TmpModalCustom>
                {/* Modal de confirmação de exclusão */}

            </>
            : <>
                <Wrapper>
                    {props.rows.map((row, indexRow) => (
                        <Collapsable key={`collapsable-${indexRow}`}>
                            <AccordionTable
                                opened={_isOpened}
                                aria-expanded={_isOpened}
                                aria-controls={`controls-${indexRow}`}
                                id={`accordion-${indexRow}`}
                                onClick={_handleOpen}
                            >
                                <AccordionTableLabel>
                                    {row[_mobileTitle.property]}
                                </AccordionTableLabel>
                                <TmpIconCustom
                                    size="sm"
                                    icon={
                                        <Chevron />
                                    }
                                />
                            </AccordionTable>
                            <ContentAccordionTable
                                opened={_isOpened}
                                role="region"
                                area-labelledby={`accordion-${indexRow}`}
                                id={`controls-${indexRow}`}
                            >
                                {props.columns.map((header, intexH) => (
                                    header.property !== _mobileTitle.property && (
                                        <ContentRow key={intexH}>
                                            <ContentLabel>
                                                {header.title}
                                            </ContentLabel>
                                            <ContentData>
                                                {header.type === "text" ?
                                                    <div key={"row_" + intexH} >{row[header.property]}</div>
                                                    : header.type === "date" ?
                                                        <div key={"row_" + intexH}  >{DateToString(row[header.property])}</div>
                                                        : header.type === "boolean" ?
                                                            <div key={"row_" + intexH} >{row[header.property] ? "Sim" : "Não"}</div>
                                                            : null
                                                }
                                            </ContentData>
                                        </ContentRow>
                                    )
                                ))}
                            </ContentAccordionTable>
                        </Collapsable>
                    ))}
                </Wrapper>

            </>
    )

}